/*
 * Keep Filament's keyBindings() working inside modals after Livewire re-renders them
 * On every update Livewire lets Alpine run directives on a temporary copy of the new HTML. Alpine's own directives
 * skip that copy, but the mousetrap directive behind keyBindings() rebinds its keys to it, and then ignores them
 * because the copy is never inside the open modal. Registered before Filament's scripts, so we can make it skip the copy too.
 */

document.addEventListener('alpine:init', () => {
    const directive = Alpine.directive;

    Alpine.directive = (name, callback) =>
        directive(name, name === 'mousetrap' ? Alpine.skipDuringClone(callback) : callback);
});
